import React, { useMemo } from "react";

import { ReactComponent as OperationFIVG } from "../assets/svg/Header/OperationFIVG.svg";
import { ReactComponent as OperationBORM } from "../assets/svg/Header/OperationBORM.svg";
import { ReactComponent as OperationBCSH } from "../assets/svg/Header/OperationBCSH.svg";
import HeaderMakro from "../assets/png/Header/HeaderMakro.jpg";

import { mainApi } from "../store/services/mainApi";

// 🔥 RTK Query: GET suppliers
export const useGetSuppliersLinkQuery =
    mainApi.endpoints.getSuppliersLink?.useQuery;

// 🎨 Иконки на фронте
const supplierIconsByLink = {
  makro: <img src={HeaderMakro} width="30" height="30" alt="Makro" />,
  gama: <OperationFIVG width="30" height="30" />,
  cocktailshop: <OperationBCSH width="30" height="30" />,
  oriental: <OperationBORM width="30" height="30" />,
};

const getSupplierIcon = (supplier) => {
  // если с БД пришла iconUrl — рисуем её
  if (supplier?.iconUrl) {
    return (
        <img
            src={supplier.iconUrl}
            width={30}
            height={30}
            alt={supplier?.name || "icon"}
            style={{ borderRadius: 6, objectFit: "cover", display: "block" }}
            onError={(e) => (e.currentTarget.style.display = "none")}
        />
    );
  }

  return supplierIconsByLink[supplier?.link] ?? (
      <span style={{ width: 30, display: "inline-block" }}>🏬</span>
  );
};

// ✅ элемент-кнопка (последний)
const ADD_SUPPLIER_ITEM = {
  type: "action",
  action: "openAddSupplierModal",
  name: "Add supplier",
  enabled: true,
  disabled: false,
  permission: true,
  link: "__add_supplier__",
  tradeName: "__add_supplier__",
  icon: (
      <span
          style={{
            width: 30,
            height: 30,
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 18,
            background: "rgba(6,192,176,0.12)",
            border: "1px solid rgba(0,0,0,0.08)",
          }}
      >
      +
    </span>
  ),
};

export const useSuppliersList = () => {
  const fallback = [
    { permission: true, link: "makro", name: "Makro", enabled: true, disabled: false, tradeName: "MCH" },
    { permission: true, link: "gama", name: "Cuarta(IV)gama", enabled: true, disabled: false, tradeName: "FIVG" },
    { permission: true, link: "cocktailshop", name: "Cocktailshop", enabled: true, disabled: false, tradeName: "B-CSH" },
    { permission: true, link: "oriental", name: "OrientalMarket", enabled: true, disabled: false, tradeName: "B-ORM" },
  ];

  const { data, isLoading, isError, refetch } = useGetSuppliersLinkQuery?.() ?? {
    data: fallback,
    isLoading: false,
    isError: false,
    refetch: undefined,
  };

  const SUPPLIERS_LIST = useMemo(() => {
    const base = Array.isArray(data) ? data : [];

    const mapped = base.map((el) => ({
      ...el,
      type: "supplier",
      icon: getSupplierIcon(el),
    }));

    // ✅ всегда добавляем последним пунктом кнопку
    return [...mapped, ADD_SUPPLIER_ITEM];
  }, [data]);

  return {
    SUPPLIERS_LIST,
    isLoading,
    isError,
    refetch,
  };
};
